import React from 'react';
import { node, object } from 'prop-types';
import InquiryFlowChrome from './InquiryFlowChrome';
import css from './InquiryChoiceFlow.module.css';

const InquiryChoiceFlow = ({ params, breadcrumbs, sidebar, children }) => (
  <InquiryFlowChrome
    backLinkName="ListingPage"
    backLinkParams={{ id: params.id, slug: params.slug }}
  >
    <div className={css.layout}>
      <div className={css.main}>
        <div className={css.breadcrumbs}>{breadcrumbs}</div>
        {children}
      </div>
      {sidebar ? (
        <aside className={css.sidebar}>
          <div className={css.sidebarCard}>{sidebar}</div>
        </aside>
      ) : null}
    </div>
  </InquiryFlowChrome>
);

InquiryChoiceFlow.defaultProps = {
  sidebar: null,
};

InquiryChoiceFlow.propTypes = {
  params: object.isRequired,
  breadcrumbs: node.isRequired,
  sidebar: node,
  children: node.isRequired,
};

export default InquiryChoiceFlow;
